var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fa-spin2"},[_c('img',{staticClass:"ico-17 fa-spin",attrs:{"src":require("../assets/icons/spinner.svg")}})])
}]

export { render, staticRenderFns }